import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
export function useToggle(initial) {
  const $ = _c(3);
  const [s, setS] = useState(initial);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = function toggle() {
      setS(_temp);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const toggle = t0;
  let t1;
  if ($[1] !== s) {
    t1 = [s, toggle];
    $[1] = s;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function _temp(s_0) {
  return !s_0;
}